import * as React from 'react';

function SvgSouthAfrica(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.789h35.534V.058H0v20.73z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.227.058L16.59 6.966h18.944V.058H6.227z"
        fill="#D03033"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.592 6.966l2.073 1.381h16.87v-1.38H16.591zM18.666 12.496l-2.074 1.386h18.943v-1.386h-16.87z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.592 13.882L6.227 20.788h29.307v-6.906H16.592z"
        fill="#1F189B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.966h4.134L0 4.208v2.758zM0 6.966v6.916h4.134l5.184-3.462-5.184-3.454H0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.882v2.754l4.134-2.754H0z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.208l9.318 6.212L0 16.636v1.66l11.81-7.876L0 2.548v1.66z"
        fill="#F2B126"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 .058v2.49l11.81 7.872L0 18.294v2.495h3.736l12.439-8.293h19.36v-4.15h-19.36L3.735.059H0z"
        fill="#32784C"
      />
    </svg>
  );
}

export default SvgSouthAfrica;
